const cleanEnv = (value?: string) => value?.replace(/^['"]|['"]$/g, '') || '';

const authDomain = cleanEnv(process.env.REACT_APP_AUTH_DOMAIN);

export const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: cleanEnv(process.env.REACT_APP_USER_POOL_ID),
      userPoolClientId: cleanEnv(process.env.REACT_APP_USER_POOL_WEB_CLIENT_ID),
      ...(authDomain
        ? {
            loginWith: {
              oauth: {
                domain: authDomain,
                scopes: ['openid', 'email', 'profile'],
                redirectSignIn: [cleanEnv(process.env.REACT_APP_REDIRECT_SIGN_IN)],
                redirectSignOut: [cleanEnv(process.env.REACT_APP_REDIRECT_SIGN_OUT)],
                responseType: 'code' as const,
              },
            },
          }
        : {}),
    },
  },
};
